module.exports = __webpack_public_path__ + "media/images/content/pic_direction_sw-c31083db5e3f60dabb7c608fefa43586.svg";